import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore();

const store = {
  state: {
    estudioSelect:{},
    catalogo_estudios:{},
    estudios_sucursal:{},
    estudios_principales:{},
  },
  getters: {
      estudioSeleccionado: state => {
        return state.estudioSelect;
      },
      catalogo_estudios:state =>{
        return state.catalogo_estudios;
      },
      estudios_sucursal:state => {
        return state.estudios_sucursal;
      },
      estudios_principales:state => {
        return state.estudios_principales;
      }
  },
  mutations: {
      ASIGNA_ESTUDIO_SELECCIONADO(state, data) {
        state.estudioSelect = data;
      },
      ASIGNA_CATALOGO_ESTUDIOS(state, data) {
        state.catalogo_estudios = data;
      },
      ASIGNA_ESTUDIOS_SUCURSAL(state,data){
        state.estudios_sucursal = data;
      },
      ASIGNA_ESTUDIOS_PRINCIPALES(state,data){
        state.estudios_principales = data;
      }
  },
  actions: {

    restablecerValoresEstudios({commit}){
      commit('ASIGNA_ESTUDIOS_PRINCIPALES',{})
      commit('ASIGNA_PRODUCTO_SELECCIONADO', {})
      commit('ASIGNA_CATALOGO_ESTUDIOS',{});
    },

    cargaEstudiosParaActualizacion({getters,commit}){
      return new Promise((resolve, reject) => {
          db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.ESTUDIOS).get().then((querySnapshot) => {
          //commit('ASIGNA_SERVICIOS',querySnapshot.data());
          let estudios_principales = []
          for(var i in querySnapshot.data().children){
            let estudios = querySnapshot.data().children[i];
            if (Object.keys(estudios).length > 0) {
              for(var j in estudios.children){
                  if (Object.keys(estudios.children[j]).length > 0) {
                    estudios_principales.push(estudios.children[j])
                  }
              }
            }
          }
          commit('ASIGNA_ESTUDIOS_PRINCIPALES',estudios_principales)
          resolve(estudios_principales);
        });
      })
    },

    cargaEstudioSeleccionado({ commit,getters }, idEstudio) {
      console.log('Store estudio carga: ' + idEstudio)
      return new Promise((resolve, reject) => {
        let docPath = db.collection("Franquicias").doc(getters.franquicia.id)
        .collection("Estudios").doc(idEstudio);
        docPath.get().then(doc => {
          commit('ASIGNA_PRODUCTO_SELECCIONADO', doc.data())
          resolve(doc.data())
        }).catch(error => {
          reject(error);
        })
      })
    },

    actualizaEstudioSeleccionado({getters}, data) {
      console.log(data);
      //Modificar estudio
      db.collection("Franquicias").doc(getters.franquicia.id)
      .collection("Estudios").doc(data[1]).set(data[0]);
      //Modificar tree
      db.collection("Franquicias").doc(getters.franquicia.id)
      .collection("Catalogos").doc("Estudios").set(data[2]);
    },

    cargaCatalogoEstudios({getters,commit},){
        return new Promise((resolve, reject) => {
          let docPath = db.collection("Franquicias").doc(getters.franquicia.id)
          .collection("Catalogos").doc("Estudios");
          docPath.get().then(querySnapshot => {
            var data = [];
            if(querySnapshot.data() !== undefined) {
              data = querySnapshot.data();
            } else {
              data = {children:[],name:"Estudios"};
            }
            commit('ASIGNA_CATALOGO_ESTUDIOS',data);
            resolve(data)
          })
        });
    },

    cargaEstudiosSucursal({commit}, idSucursal) {
      return new Promise((resolve,reject) => {
        db.collection("Sucursales").doc(idSucursal)
        .collection("Indices").doc("Estudios").onSnapshot((querySnapshot) => {
          console.log(`Sucursales/${idSucursal}/Indices/Estudios`,querySnapshot.data())
          const estudios = querySnapshot.data()!==undefined ? querySnapshot.data() : {};
          commit('ASIGNA_ESTUDIOS_SUCURSAL',estudios);
          resolve();
        });
      })
    },

    inhabilitarEstudio({getters}, idEstudio){
      var obj = {estatus:{activo:"baja"}}
      return db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.ESTUDIOS).doc(idEstudio).set(obj,{merge:true})
    },

    actualizarEstudiosV1({getters, dispatch }){
      return new Promise((resolve,reject) => {
        dispatch('cargaEstudiosParaActualizacion').then(() => {
          console.log("Actualizar estudios carga estudios store", getters.estudios_principales)
          //Creamos las transacciones para actualizar los datos
          var batch = db.batch();
          let estudios = getters.estudios_principales
          for(var i in estudios){
            if(estudios[i].delete){
              let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
              .collection(FS_COLLECTIONS.ESTUDIOS).doc(estudios[i].id)
              console.log("Actualizar estudio store" + estudios[i].id)
              batch.set(ref, {estatus:{activo:"baja"}}, {merge:true})
            }
          }
          //Cuando todas las transacciones estan listas se ejecuta esta linea
          batch.commit().then(() => {
            console.log("STORE TERMINA EJECUCION ESTUDIOS")
            //Actualizamos rama de productos a version 1.0
            db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.ESTUDIOS)
            .set({version:'1.0'},{merge:true}).then(() => {
              resolve(true)
            }).catch(error => {
              reject(error);
            })
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/estudios/estudios.js